import { MomentAll } from 'ngx-bootstrap/chronos/test/chain';

// request
export interface DashboardRequest {
  SubCompanyCode: string;
}

export interface DashboardAdvancedSearchRequest {
  AgencyId: string;
  PolicyIdentifier: string;
  InsuredName: string;
}

// response
export interface DashboardResponse {
  PendingClaimResponse: PendingClaimResponse;
  PendingClaimReservesResponse: PendingClaimReservesResponse;
  PendingClaimPaymentsResponse: PendingClaimPaymentsResponse;
  Policies: Policies;
  Status: string;
}
export interface Policies {
  PolicyID: number;
  VersionNum: number;
  BindDate: string;
  EffectiveDate: string;
  SubmissionID: string;
  PolicyNumber: string;
  Insured: string;
  PolicyType: string;
  Type: string;
  AgentName: string;
  Premium: string;
  Status: string;
  PreviousExpirationDate?: null;
  PreviousPolicyNumber?: null;
  PreviousPolicyID?: null;
  PreviousVersionNumber?: null;
}

export interface PendingClaimResponse {
  PendingClaimCount: number;
}

export interface PendingClaimPaymentsResponse {
  PendingClaimPaymentsCount: number;
  PendingClaimPayments: PendingClaimPayment[];
}

export interface PendingClaimReservesResponse {
  PendingReserversCount: number;
  PendingClaimReserves: PendingClaimReserve[];
}

export interface PendingClaimPayment {
  ClaimPaymentId: number;
  SubCompanyCode: string;
  ClaimTxnStatus: string;
  MailToFileAsName?: string;
  BilledTotal: number;
  PaidTotal: number;
  CurrencyCode: string;
  CreationDate: string;
  CreationUser: string;
  ClaimPaymentDetailId: number;
  ClaimNum: string;
  LineOfBusiness: string;
  BilledAmt: number;
  DetailAmt: number;
  ClaimPaymentType: string;
  CovType: string;
  ClaimId: number;
  RiskDescription: string;
  Insured: string;
  LossDate: string;
  ClaimsAttorney: string;
}

export interface PendingClaimReserve {
  ClaimId: number;
  ClaimReserveId: number;
  ClaimTxnStatus: string;
  ClaimNum: string;
  InsuredFileAsName: string;
  ClaimEntryType: string;
  ReserveCat: string;
  LineOfBusiness: string;
  CreationDate: string;
  CreationUser: string;
  CurrencyCode: string;
  ReserveAmt: number;
  ReserveReason?: string;
  PerOccurLimit: number;
  AggregateLimit: number;
  TotalIncurred: number;
  UserRole1: number;
  UserRole2: number;
  AdjustTypeCode: string;
  EnteredAmt: number;
  DefensePerOccurLimit: number;
  DefenseAggregateLimit: number;
  RiskDescription: string;
  LossDate: string;
}

export interface ApprovedRequest {
  reserves: [];
  ClaimID: number;
  SubcompanyCode: string;
  IsBulkApprove: boolean;
}

export interface DeclineRequest {
  ClaimID: number;
  SubcompanyCode: string;
  IsBulkDecline: boolean;
}

export interface ApprovedRequestPost {
  reserves: reservesClaimId[];
  SubcompanyCode: string;
  IsBulkApprove: boolean;
  isBulkDecline: boolean;
}

export interface reservesClaimId {
  claimReserveId: string;
  ClaimID: string;
}

export interface ApprovedRequestPayment {
  payments: any[];
  IsBulkApprove: boolean;
  IsBulkDecline: boolean;
  SubCompanyCode: string;
}
export interface payments {
  ClaimPaymentId: string;
}

export interface ClaimDashBoardMetrics {
  SubCompanyCode: string;
  ClaimAttorney: string;
}

export interface AgencyLossRunRequest {
  SubCompanyCode: string;
  AgencyContactId: string;
}

export interface AgencyLossRunResponse {
  Base64Result: string;
  Status: string;
  Warnings: Array<string>;
  Errors: Array<string>;
}

export interface BoundPolicyReportRequest {
  AgencyContactId: number;
  SortColumn: string;
  SortOrder: string;
}

export interface BoundPolicyReportResponse {
  CasualtyBoundPolicies: CasualtyBoundPolicy[];
  Validations: Array<any>;
}

export interface CasualtyBoundPolicy {
  Policy: string;
  Agency: string;
  AgencyCity: string;
  AgencyState: string;
  Insured: string;
  PolicyEffectiveDate: string;
  PolicyExpirationDate: string;
  WrittenPremium: string;
  WrittenPolicyFee: string;
  WrittenPremiumTax: string;
}
